import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CardActivationStackRoutes, CardActivationStackScreenProps } from './type';
import { CardActivationWebOneScreen } from './CardActivationWebOne.screen';
import { CardActivationNativeOneScreen } from './CardActivationNativeOne.screen';

export interface CardActivationProps {}
export const CardActivationPlaced: React.FC<CardActivationStackScreenProps<CardActivationStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, account, tab, record, data, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <CardActivationNativeOneScreen onClose={onGoBack} account={account} tab={tab} record={record} data={data} refresh={refresh} />;
  }

  return (
    <CardActivationWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      account={account}
      tab={tab}
      record={record}
      data={data}
      refresh={refresh}
    />
  );
};
